import {LegacyRegulationWrapper} from '../legacy-regulation-wrapper'

export class GermanyRegulation extends LegacyRegulationWrapper {

  async logoutUser(): Promise<void> {
    await this.services.specificDialogs.showConfirmLugasCoolingOffLogout({
      onAccept: async () => super.logoutUser(),
      onReject: async () => {},
    });
  }
}